<div class="text-end">
  <button nz-button (click)="close()">Close</button>
</div>
<div *ngIf="type === 'DESTINATION'">
  <h6>Descriptions</h6>
  <nz-form-item class="lg:flex my-4">
    <nz-form-control>
      <input
        nz-input
        placeholder="Search"
        [(ngModel)]="keyword"
        (ngModelChange)="searchDescriptions()" />
    </nz-form-control>
  </nz-form-item>
  <nz-list *ngIf="filteredDescriptions?.length; else noDataBlock" nzBordered class="my-4">
    <nz-list-item *ngFor="let desc of filteredDescriptions">
      <div class="w-full">
        <p *ngFor="let paragraph of desc.split('\n')" class="my-3">{{ paragraph }}</p>
        <div class="text-end">
          <button nz-button (click)="closeWithData(desc)">Select</button>
        </div>
      </div>
    </nz-list-item>
  </nz-list>
</div>

<div *ngIf="type === 'CITY'">
  <h6>Descriptions</h6>
  <nz-form-item class="lg:flex my-4">
    <nz-form-control>
      <input
        nz-input
        placeholder="Search"
        [(ngModel)]="keyword"
        (ngModelChange)="searchDescriptions()" />
    </nz-form-control>
  </nz-form-item>
  <nz-list *ngIf="filteredDescriptions?.length; else noDataBlock" nzBordered class="my-4">
    <nz-list-item *ngFor="let desc of filteredDescriptions">
      <div class="w-full">
        <p *ngFor="let paragraph of desc.split('\n')" class="my-3">{{ paragraph }}</p>
        <div class="text-end">
          <button nz-button (click)="closeWithData(desc)">Select</button>
        </div>
      </div>
    </nz-list-item>
  </nz-list>
</div>
<div *ngIf="type === 'ACTIVITIES'">
  <h6>Activities</h6>
  <nz-form-item class="lg:flex my-4">
    <nz-form-control>
      <input
        nz-input
        placeholder="Search"
        [(ngModel)]="keyword"
        (ngModelChange)="searchActivities()" />
    </nz-form-control>
  </nz-form-item>
  <nz-list *ngIf="filteredActivities?.length; else noDataBlock" nzBordered class="my-4">
    <nz-list-item *ngFor="let act of filteredActivities">
      <div class="w-full">
        <p>{{ act?.title }}</p>
        <div class="text-end">
          <button nz-button [disabled]="disableSelectItemIds.includes(act._id)" (click)="closeWithData(act)">Select</button>
        </div>
      </div>
    </nz-list-item>
  </nz-list>
</div>
<div *ngIf="type === 'ATTRACTIONS'">
  <h6>Attractions</h6>
  <nz-form-item class="lg:flex my-4">
    <nz-form-control>
      <input
        nz-input
        placeholder="Search"
        [(ngModel)]="keyword"
        (ngModelChange)="searchAttractions()" />
    </nz-form-control>
  </nz-form-item>
  <div *ngIf="filteredAttractions?.length; else noDataBlock" nzBordered class="my-4">
    <div *ngFor="let a of filteredAttractions">
      <div class="grid grid-cols-12 gap-6">
        <div *ngIf="a.image" class="col-span-4 flex items-center">
          <img
            class="w-full object-cover"
            [src]="a.image ? a.image : placeholderPath"
            alt="" />
        </div>
        <div [ngClass]="isFullWidth(a)">
          <h5>{{ a.title }}</h5>
          <p nz-typography nzEllipsis nzEllipsisRows="3">{{ a.description }}</p>
        </div>
      </div>
      <div class="text-end">
        <button nz-button [disabled]="disableSelectItemIds.includes(a._id)" (click)="closeWithData(a)">Select</button>
      </div>
      <nz-divider></nz-divider>
    </div>
  </div>
</div>
  <ng-template #noDataBlock>
    <div>
      <nz-list [nzDataSource]="[]"></nz-list>
    </div>
  </ng-template>
